<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<div class="flex flex-auto justify-center w-full sm:p-4 md:p-8 bg-gray-200 dark:bg-slate-950">

    <!-- Navigation -->
    <ng-container *ngIf="isScreenSmall">
        <fuse-vertical-navigation class="dark bg-gray-900 print:hidden" [mode]="'over'" [name]="'mainNavigation'"
            [navigation]="navigation.default" [opened]="false">
            <!-- Navigation header hook -->
            <ng-container fuseVerticalNavigationContentHeader>
                <!-- Logo -->
                <!-- <div class="flex items-center h-20 pt-6 px-8">
                    <img
                        class="w-30"
                        src="assets/images/logo/logo1.png">
                </div> -->
            </ng-container>
        </fuse-vertical-navigation>
    </ng-container>
    <fuse-vertical-navigation class="bg-primary-300 print:hidden" [mode]="'over'" [name]="'B2CNavigation'"
        [navigation]="navigation?.horizontal" [opened]="false">
        <!-- Navigation header hook -->
        <ng-container fuseVerticalNavigationContentHeader>
            <!-- Logo -->
            @if(view.site) {
            <div class="flex items-center h-20 pt-6 px-8">
                <img class="w-40" [src]="view.site?.logoUrl" alt="Logo image">
            </div>
            }
        </ng-container>
    </fuse-vertical-navigation>

    <!-- Wrapper -->
    <div
        class="flex flex-col items-center flex-auto min-w-0 max-w-360 sm:rounded-xl shadow-2xl dark:shadow-none overflow-hidden">

        <!-- Header -->
        <div
            class="relative flex flex-0 items-center w-full h-16 sm:h-20 px-4 md:px-6 z-49 bg-card border-b dark:bg-default print:hidden">
            <ng-container *ngIf="!isScreenSmall">
                <!-- Logo: sites 88 / 96 — column only as wide as logo to avoid extra gap -->
                <div class="flex items-center mx-2" [ngClass]="isEliteMemberLayoutSite ? 'shrink-0' : ''">
                    <div class="hidden lg:flex">

                        <a [routerLink]="'/'" class="flex items-center [&>div]:shrink-0">
                            @if(view.site && isEliteMemberLayoutSite) {
                            <div class="flex items-center max-w-[10rem]">
                                <img class="max-w-full h-auto" [src]="view.site?.logoUrl" alt="Logo image">
                            </div>
                            }
                            @if(view.site && view.site?.id != 51 && view.site?.id != 76 && view.site?.id != 89 && !isEliteMemberLayoutSite) {
                            <div class="flex items-center" style="max-width: 65%">
                                <img [ngClass]="view.site?.id == 146 ? 'w-64' : (view.site?.id == 72 ? 'w-[300px]' : 'w-[380px]')" [src]="view.site?.logoUrl" alt="Logo image">
                            </div>
                            }
                            @if(view.site && (view.site?.id == 51 || view.site?.id == 76)) {
                            <div class="flex items-center" style="max-width: 65%">
                                <img class="w-64" [src]="view.site?.logoUrl" alt="Logo image">
                            </div>
                            }
                            @if(view.site?.id == 89) {
                            <div class="flex items-center">
                                <img class="w-32" [src]="view.site?.logoUrl" alt="Logo image">
                            </div>
                            }
                        </a>
                    </div>
                    <!-- Small version -->
                    <img class="flex lg:hidden w-8" [src]="view.site?.logoUrl2" alt="Logo image">
                </div>
                <!-- Horizontal navigation: sites 88 / 96 — center nav in remaining space -->
                <div class="flex-1 flex justify-center min-w-0" [class.site-88-nav-center]="isEliteMemberLayoutSite">
                    <fuse-horizontal-navigation class="text-3xl mr-2" [class.site-72-nav]="view.site?.id === 72" [class.site-88-nav]="isEliteMemberLayoutSite" [name]="'mainNavigation'"
                        [navigation]="navigation?.horizontal"></fuse-horizontal-navigation>
                </div>
            </ng-container>
            <!-- Navigation toggle button -->
            <ng-container *ngIf="isScreenSmall">
                @if (!view.isClient) {
                <button class="mr-2" mat-icon-button (click)="toggleNavigation('mainNavigation')">
                    <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                </button>
                }
                <!-- <search></search> -->
            </ng-container>
            @if (view.isClient) {
            <ng-container *ngIf="isScreenSmall">
                <button mat-icon-button (click)="toggleNavigationB2C('B2CNavigation')">
                    <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                </button>
                @if(view.site.agencyID == 23) {
                <div class="hidden md:flex items-center h-20 px-8">
                    <img class="w-10 md:w-20" [src]="view.site?.logoUrl2" alt="Logo image">
                </div>
                <div class="flex items-center md:hidden h-20 px-8">
                    <img class="w-36" [src]="view.site?.logoUrl" alt="Logo image">
                </div>
                }
            </ng-container>
            }
            <!-- Components -->
            <div class="flex items-center pl-2 ml-auto space-x-1 sm:space-x-2">
                <div class="flex w-23 items-center">
                    <!-- <a [routerLink]="'/onboarding'" class="w-full rounded-md text-primary-500 text-center text-xs lg:text-sm uppercase font-semibold p-2 bg-accent-500 mr-2 hover:bg-primary-500 duration-500 hover:text-white">Become a Member</a> -->
                    <section class="hidden xl:block">
                        <!-- @if(view.site?.id != 146) { -->
                        <div *ngIf="view?.site" class="flex">
                            @if(view.site?.socialUrlFacebook) {
                            <a href="{{view.site?.socialUrlFacebook}}" target="_blank"
                                class="group w-8 h-8 mr-2  rounded-xl transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                                <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                                    [svgIcon]="'feather:facebook'"></mat-icon>
                            </a>
                            }
                            @if(view.site?.socialUrlInstagram) {
                            <a href="{{view.site?.socialUrlInstagram}}" target="_blank"
                                class="group  w-8 h-8 mr-2 rounded-xl transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                                <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                                    [svgIcon]="'feather:instagram'"></mat-icon>
                            </a>
                            }
                            @if(view.site?.socialUrlTwitter) {
                            <a href="{{view.site?.socialUrlTwitter}}" target="_blank"
                                class="group relative w-8 h-8 mr-2 rounded-xl transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                                <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                                    [svgIcon]="'feather:twitter'"></mat-icon>
                            </a>
                            }
                            @if(view.site?.socialUrlLinkedIn) {
                            <a href="{{view.site?.socialUrlLinkedIn}}" target="_blank"
                                class="group relative w-8 h-8 mr-2 rounded-xl transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                                <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                                    [svgIcon]="'feather:linkedin'"></mat-icon>
                            </a>
                            }
                            @if(view.site?.socialUrlPinterest) {
                            <a href="{{view.site?.socialUrlPinterest}}" target="_blank"
                                class="group relative w-8 h-8 mr-2 rounded-xl transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                                <svg fill="#ffffff" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                    <g id="SVGRepo_iconCarrier">
                                        <path
                                            d="M16.292 5C10.536 5 7.48 8.866 7.48 13.077c0 1.955 1.039 4.392 2.707 5.168.253.118.387.064.443-.18.047-.185.273-1.089.373-1.511a.402.402 0 0 0-.095-.386c-.55-.667-.988-1.896-.988-3.041 0-2.942 2.228-5.787 6.021-5.787 3.28 0 5.571 2.23 5.571 5.426 0 3.61-1.82 6.108-4.191 6.108-1.309 0-2.291-1.081-1.978-2.413.378-1.584 1.106-3.298 1.106-4.438 0-1.026-.552-1.883-1.685-1.883-1.341 0-2.415 1.385-2.415 3.241 0 1.182.4 1.978.4 1.978s-1.323 5.593-1.563 6.634c-.413 1.765.051 4.625.094 4.876.021.134.172.18.252.066.129-.175 1.725-2.565 2.174-4.292l.828-3.171c.439.829 1.707 1.531 3.061 1.531 4.021 0 6.923-3.703 6.923-8.299C24.52 8.301 20.92 5 16.292 5z">
                                        </path>
                                    </g>
                                </svg>
                            </a>
                            }
                            @if(view.site && (view.site.id === 146 || view.site.id === 72) ) {
                            <a href="{{view.site?.socialUrlYouTube}}" target="_blank"
                                class="group relative w-8 h-8 mr-2 rounded-xl transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                                <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                                    [svgIcon]="'feather:youtube'"></mat-icon>
                            </a>
                            }
                            @if(view.site?.id === 104 || view.site?.id == 89 || view.site?.id == 120 || view.site?.id == 163) {
                            <div class="flex items-center justify-center">
                                <mat-icon class="icon-size-5 text-accent mr-3"
                                    svgIcon="heroicons_outline:phone"></mat-icon>
                                {{ view.site?.telephone }}
                            </div>
                            }
                            @if(view.site?.id == 70) {
                            <div class="flex items-center justify-center">
                                <mat-icon class="icon-size-5 text-accent mr-3"
                                    svgIcon="heroicons_outline:envelope"></mat-icon>
                                {{ view.site?.emailAddress }}
                            </div>
                            }
                        </div>
                        <!-- } -->

                    </section>
                </div>

                <!-- <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
                <shortcuts></shortcuts>
                
                <messages></messages>
                <user></user> -->
            </div>
        </div>

        <!-- Content -->
        <div class="flex flex-col flex-auto w-full bg-default">
            <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
                 Otherwise, layout changes won't be registered and the view won't be updated! -->
            <router-outlet *ngIf="true"></router-outlet>
        </div>

        <!-- Dynamic cart section -->
        @if (view.isClient && view.data.cart && view.data.cart.length > 0) {
        <mat-drawer
            class="m-auto dark:bg-gray-900 transition-all duration-500 fixed bottom-0 shadow-2xl w-11/12 bg-white pb-3 rounded-t-lg border-2 border-b-0 border-primary opacity-0"
            [class.z-99]="view.data.cart && view.data.cart.length > 0"
            [class.opacity-[97]]="view.data.cart && view.data.cart.length > 0 || view.itinGuid" [position]="'end'"
            [autoFocus]="false" [mode]="view.drawerOptions && view.drawerOptions.mode == 'review' ? 'side' : drawerMode"
            [disableClose]="false" [opened]="view.data.cart && view.data.cart.length > 0" #drawerRight>
            <cart [options]="{loadCache:false, isClient:view.isClient, compactColumns: true}" (viewChange)="viewChanged($event)"
                (quoteCreated)="quoteCreated($event)"></cart>
        </mat-drawer>
        }

        <!-- Footer -->
        @if (view.isClient) {
        @if (view.site && view.site.profile && view.site.profile.sections) {
        @switch (view.site.profile.sections.footer ) {
        @case (1) {
        <app-footer-type01 class="flex flex-col flex-auto items-center w-full min-w-0"></app-footer-type01>
        }
        @case (2) {
        <app-footer-type02 class="flex flex-col flex-auto items-center w-full min-w-0"></app-footer-type02>
        }
        @case (3) {
        <app-footer-type03 class="flex flex-col flex-auto items-center w-full min-w-0 z-50"></app-footer-type03>
        }
        @case (4) {
        <app-footer-type04 class="flex flex-col flex-auto items-center w-full min-w-0 z-50"></app-footer-type04>
        }
        @case (5) {
        <app-footer-type05 class="flex flex-col flex-auto items-center w-full min-w-0 z-50"></app-footer-type05>
        }
        @case (6) {
        <app-footer-type06 class="flex flex-col flex-auto items-center w-full min-w-0"></app-footer-type06>
        }
        @case (7) {
        <app-footer-type07 class="flex flex-col flex-auto items-center w-full min-w-0"></app-footer-type07>
        }
        }
        }
        }
        </div>
</div>
